export const ADBLOCK = "ADBLOCK";
export const ADBLOCK_START_LOADER = "ADBLOCK_START_LOADER";
export const ADBLOCK_STOP_LOADER = "ADBLOCK_STOP_LOADER";
export const ADBLOCK_HIDE_ERROR = "ADBLOCK_HIDE_ERROR";
export const ADBLOCK_SET_ERROR = "ADBLOCK_SET_ERROR";
